<template>
  <div
      class="card"
      @click="openEditLine(keyName)"
  >
    <div class="card-body">
    <template v-if="!ledger.is_edit">
      <div class="row ledger-header fw-bold border-bottom mb-2 pb-1">
        <div class="col-12 col-md-2 col-lg-1 head-text">Date</div>
        <div class="col-12 col-md-3 col-lg-3 head-text">Account Head</div>
        <div class="col-12 col-md-3 col-lg-6 head-text">Description</div>
        <div class="col-12 col-md-2 col-lg-1 head-text text-end">Receipt</div>
        <div class="col-12 col-md-2 col-lg-1 head-text text-end">Payment</div>
      </div>
      <div class="row ledger-row" v-for="(item, i) in ledger.ledgers" :key="i">
          <div class="col-12 col-md-2 col-lg-1">
            <span class="card-date" :class="{'text-danger': !item.validation_date}">
            {{ item.date }}
            </span>
          </div>
          <div class="col-12 col-md-3 col-lg-3">
            <div class="card-account" :class="{'text-danger': !item.validation_account_head || !item.validation_same_head_mop}">
              {{ item.account_head  }}
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-6">
            <div class="card-meta">
              <span v-if="item.party" class="meta-item"><span class="meta-label">Party:</span> {{ item.party }}</span>
              <span v-if="item.business" class="meta-item"><span class="meta-label">BU:</span> {{ item.business }}</span>
              <span v-if="item.cost_center" class="meta-item"><span class="meta-label">CC:</span> {{ item.cost_center }}</span>
              <span v-if="item.project" class="meta-item"><span class="meta-label">Project:</span> {{ item.project }}</span>
              <span v-if="item.budget_general" class="meta-item"><span class="meta-label">Budget:</span> {{ item.budget_general }}</span>
            </div>
            <div v-if="item.note" class="card-note">{{ item.note }}</div>
          </div>
          <div class="col-12 col-md-2 col-lg-1 text-end">
             <span v-if="item.debit != null" class="amount-chip" :class="{'text-danger': !item.validation_debit_credit}">
               {{ item.debit }}
            </span>
          </div>
          <div class="col-12 col-md-2 col-lg-1 text-end">
               <span v-if="item.credit != null" class="amount-chip" :class="{'text-danger': !item.validation_debit_credit}">
                 {{ item.credit }}
              </span>
          </div>
        </div>
    </template>

    <template v-else>
      <div v-for="(item, i) in ledger.ledgers" :key="i">
        <div class="row" @click.stop>
            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Date</label>
              <input type="date" class="form-control" :value="item.date" :item="`${i}`" @change="onChangeDate" ref="date">
            </div>

            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Account Head</label>
              <AsyncSelect
                  placeholder="Select Account Head"
                  v-model="item.account_head"
                  :api-service="fetchAccountHeadsList"
                  :reduce="name => name.name"
              />
            </div>

            <div
                class="col-md-4 col-lg-3 col-12"
                v-if="item.debit != null || (item.credit == null && item.debit == null)"
            >
              <label class="col-form-label">Receipt</label>
              <input
                  class="text-end form-control"
                  type="text"
                  v-model="item.debit"
              >
            </div>

            <div
                class="col-md-4 col-lg-3 col-12"
                v-if="item.credit != null || (item.credit == null && item.debit == null)"
            >
              <label class="col-form-label">Payment</label>
              <input
                  class="text-end form-control"
                  type="text"
                  v-model="item.credit">

            </div>

            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Party</label>
              <AsyncSelect
                  placeholder="Select Party"
                  v-model="item.party"
                  :api-service="fetchContactProfiles"
                  :format-label="formatPatientLabel"
                  :reduce="name => name.name"
              />
            </div>

            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Business Unit</label>
              <v-select
                  v-model="item.business"
                  :options="businesses"
                  label="name"
                  :reduce="name => name.name"
              />
            </div>

            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Cost Center</label>
              <v-select
                  v-model="item.cost_center"
                  :options="costCentres"
                  label="name"
                  :reduce="name => name.name"
              />
            </div>

            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Project</label>
              <v-select
                  v-model="item.project"
                  :options="projects"
                  label="name"
                  :reduce="name => name.name"
              />
            </div>

            <div class="col-md-4 col-lg-3 col-12">
              <label class="col-form-label">Budget / Project Accounts</label>
              <v-select
                  v-model="item.budget_general"
                  :options="projectActivity"
                  label="name"
                  :reduce="name => name.name"
              />
            </div>

            <div class="col-12">
              <label class="col-form-label">Note</label>
              <textarea class="form-control" v-model="item.note" rows="2"></textarea>
            </div>
        </div>
        <div class="d-flex justify-content-end">
          <button @click.stop="onclickUpdate" class="btn btn-success btn-sm my-1">Update</button>
        </div>
      </div>
    </template>
    </div>
  </div>
</template>

<script>
import handleContact from '@/services/modules/contact'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleJournal from '@/services/modules/journal'

export default {
    name: 'LedgerRow',
    components: {AsyncSelect},
    emits:['onclickUpdate','onOpenEditItem','onclickDelete'],
    methods: {
        onclickUpdate() {
            this.$emit('onclickUpdate', {ledger: this.ledger, keyName:this.keyName})
        },

        onclickDelete() {
          this.$emit('onclickDelete', {ledger: this.ledger, keyName:this.keyName})
        },

        onChangeDate(event) {
            let index = event.target.getAttribute("item");
            this.ledger.ledgers[index].date = event.target.value
        },

        openEditLine(keyName) {
           this.$emit('onOpenEditItem', keyName)
         }
    },
    setup() {
      const { fetchContactProfiles } = handleContact()
      const { formatPatientLabel } = useAsyncDropdownHelper();
      const { fetchAccountHeadsList } = handleJournal()
      return {
        fetchContactProfiles,
        formatPatientLabel,
        fetchAccountHeadsList
      }
    },
    props: {
        ledger: Object,
        keyName: String,
        contactProfiles: Array,
        businesses: Array,
        costCentres: Array,
        projects: Array,
        projectActivity:Array,
        cashAndBack:Array,
    }
}
</script>

<style scoped>
.card-date {
  font-size: 13px;
  font-weight: 500;
  color: #000000;
}
.card-account {
  font-size: 14px;
  font-weight: 600;
  color:#000000;
  margin-bottom: 6px;
}
.card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}
.meta-item {
  font-size: 12px;
  color: #000000;
}
.meta-label {
  color: #000000;
  font-weight: 600;
  font-size:12px;
  margin-right: 3px;
}
.card-note {
  font-size: 12px;
  color: #000000;
  font-style: italic;
  padding-top: 6px;
}
.amount-chip {
  font-size: 18px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
  color: #000000;
}
.ledger-row{
  margin-bottom: 5px;
  border-bottom: 1px solid #DDDDDD;
}
.head-text{
  font-weight: 600;
  color: #000000;
}
</style>